import React from 'react'
import { RegisteredFeature } from '../utils/RegisteredFeature'
import { FeatureLink } from '../utils/FeatureLink'

export interface FeatureLinks {
  [key: string]: FeatureLink
  default: FeatureLink
}

export const createFeatureLinks = (features: { [registeredFeatureName: string]: RegisteredFeature }) => {
  const generatedFeatureSpec: FeatureLinks = Object.keys(features).reduce((featureSpec, registeredFeatureName) => {
    featureSpec[registeredFeatureName] = features[registeredFeatureName].featureLink
    return featureSpec
  }, { default: () => { throw new Error('No default exists') }})

  return generatedFeatureSpec
}



// WEBPACK FOOTER //
// ./sampleProject/src/core/feature-loading/createFeatureLinks/index.tsx